import { routes as registrationRoutes } from "./register-patient/routes";
import { routes as visitRoutes } from "./visit/routes";
import { routes as queueRoutes } from "./current-visits/routes";

export const routes = [
    ...registrationRoutes(`registration`),
    ...visitRoutes(),
    ...queueRoutes(),
];
